import React, { useState } from 'react';
import { Copy, Check, Search } from 'lucide-react';

const CodeBlock = ({ content, language = 'sql', title }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      {title && (
        <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-200">
          <h4 className="font-medium text-gray-900 flex items-center gap-2">
            <Search className="w-4 h-4" />
            {title}
          </h4>
          <button
            onClick={copyToClipboard}
            className="flex items-center gap-1 px-3 py-1 text-xs bg-gray-100 hover:bg-gray-200 rounded transition-colors"
          >
            {copied ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />}
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      )}
      <pre className="bg-gray-900 text-gray-100 p-4 overflow-x-auto text-sm">
        <code className={`language-${language}`}>{content}</code>
      </pre>
    </div>
  );
};

export default CodeBlock;
